<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-card-title class="secondary--text">{{ $capitalize($tc("model.policy_policy_title")) }}</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-id-card</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  lead.policy.number
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ $capitalize($tc("model.policy_policy_number")) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  toLocaleString(lead.policy.begin_date)
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ $capitalize($tc("model.policy_start_date_policy")) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon> </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  toLocaleString(lead.policy.end_date)
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ $capitalize($tc("model.policy_final_date_policy")) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card outlined>
        <v-card-title class="secondary--text">{{ $capitalize($tc("model.policy_money_safe")) }}</v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $capitalize($tc("model.policy_description_policy")) }}</th>
                <th class="text-right">{{ $capitalize($tc("model.policy_value_policy")) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="insurance_object in lead.policy.insurance_objects"
                :key="insurance_object.id"
              >
                <td>{{ insurance_object.type }}</td>
                <td class="text-right">
                  {{ euro(insurance_object.value) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="mt-3" outlined>
        <v-row>
          <v-col cols="12" md="7">
            <v-card-title>
              {{ $capitalize($tc("model.policy_coverings_title")) }}
              <v-spacer></v-spacer>
            </v-card-title>
          </v-col>
          <v-col class="pa-5 pt-8">
            <v-text-field
              v-model="search"
              :label="
                $capitalize($tc('model.policy_coverings_search'))
              "
              prepend-inner-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-text class="my-0 py-0">
          <v-row>
            <v-col>
              <v-switch
                v-model="showNotSelected"
                :label="
                  $capitalize($tc('model.policy_display_unselected'))
                "
              >
              </v-switch>
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="10"
          class="elevation-1"
          :loading="loading"
          :loading-text="
            $capitalize($tc('model.policy_loading_table'))
          "
          fixed-header
          max-height="500"
          show-select
          single-select
          :value="selected_item()"
          item-key="id"
          disabled
          dense
          :sort-by="['selected']"
          :sort-desc="['selected']"
          :search="search"
        >
          <template v-slot:header.product_description>
            {{ $capitalize($tc("model.policy_product_covering", 1)) }}
          </template>

          <template v-slot:header.type_description>
            {{ $capitalize($tc("model.policy_description_covering", 1)) }}
          </template>

          <template v-slot:header.capital>
            {{ $capitalize($tc("model.policy_capital_covering", 1)) }}
          </template>

          <template v-slot:header.franchise_value>
            {{ $capitalize($tc("model.policy_value_covering", 1)) }}
          </template>

          <template v-slot:header.franchise>
            {{ $capitalize($tc("model.policy_franchise_covering", 1)) }}
          </template>

          <template v-slot:header.franchise_min>
            {{ $capitalize($tc("model.policy_franchise_minimum_covering", 1)) }}
          </template>

          <template v-slot:header.franchise_max>
            {{ $capitalize($tc("model.policy_franchise_maximum_covering", 1)) }}
          </template>

          <template v-slot:header.data-table-select>
            <v-icon>mdi-check</v-icon>
          </template>

          <template v-slot:item.data-table-select="{ item }">
            <v-checkbox
              v-model="item.selected"
              style="pointer-events: none"
              readonly
            ></v-checkbox>
          </template>

          <template v-slot:item.capital="{ item }">{{
            euro(item.capital)
          }}</template>

          <template v-slot:item.franchise_value="{ item }">{{
            euro(item.franchise_value)
          }}</template>

          <template v-slot:item.franchise="{ item }"
            >{{ item.franchise }}%</template
          >

          <template v-slot:item.franchise_max="{ item }"
            >{{ item.franchise_max }}%</template
          >

          <template v-slot:item.franchise_min="{ item }"
            >{{ item.franchise_min }}%</template
          >
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Money from "../../tools/money";
import { formatDateTime } from "../../tools/date";
import goTo from "vuetify/es5/services/goto";

export default {
  data: () => ({
    headers: [
      {
        text: "Produto",
        value: "product_description",
      },
      {
        text: "Descrição",
        value: "type_description",
      },
      {
        text: "Capital",
        value: "capital",
        align: "right",
      },
      {
        text: "Valor",
        value: "franchise_value",
        align: "right",
      },
      {
        text: "Franquia",
        value: "franchise",
        align: "center",
      },
      {
        text: "Franquia Mínima",
        value: "franchise_min",
        align: "center",
      },
      {
        text: "Franquia Máxima",
        value: "franchise_max",
        align: "center",
      },
    ],
    totalItems: [],
    loading: false,
    search: "",
    showNotSelected: false
  }),
  methods: {
    selected_item() {
      return [this.items.find((item) => item.selected)];
    },
    customSort(items) {
      return items.selected;
    },
    euro(value) {
      return Money.euro(value);
    },
    toLocaleString(value) {
      return formatDateTime(value);
    },
  },
  created() {
    goTo(0);
  },
  computed: {
    lead: function () {
      return this.$store.getters.getLead;
    },
    items: function () {
      if (this.lead) {
        return this.lead.policy.coverages.filter((coverage) => {
          //Retorna todas as leads caso marcado
          if (this.showNotSelected) {
            return true;
          } else {
            // Caso contrário, apenas as selecionadas
            return coverage.selected;
          }
        });
      } else {
        return [];
      }
    }
  },
};
</script>